// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"9af4de7a","796":"e42135e6"}[chunkId] + ".chunk.js";
};